export const BASE_URL = '/sportsbook-betting-service';
export const BETS_PATH = '/public/bets';
export const BET_PATH = '/public/bet';
export const BONUS_PATH = '/public/bonus';
export const AUTHENTICATION_PATH = '/public/authentication';
